import { createEvent, createStore, sample } from "effector"
import { reset } from "patronum"
import { createCooldown } from "@callcenter/effector-helpers"
import { emailConfirmationApi } from "@callcenter/api"

export const { $isActive, trigger, restore } = createCooldown({
  effect: emailConfirmationApi.sendConfirmationEmailFx,
  storageKey: "emailConfirmationCooldownExpiresAt",
  duration: 3 * 60 * 1000
})

export const $hasError = createStore(false)
export const stateReset = createEvent()

sample({ clock: emailConfirmationApi.sendConfirmationEmailFx.fail, fn: () => true, target: $hasError })
sample({
  clock: [emailConfirmationApi.sendConfirmationEmailFx.done, emailConfirmationApi.sendConfirmationEmailFx],
  fn: () => false,
  target: $hasError
})

reset({ clock: stateReset, target: [$hasError] })
